import { render, staticRenderFns } from "./fund-performance-chart.vue?vue&type=template&id=13852882&scoped=true&"
var script = {}
import style0 from "../../../assets/styles/common/highcharts.scss?vue&type=style&index=0&id=13852882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13852882",
  null
  
)

export default component.exports